// Template Generated by DataExtraction.py at 1714175047
        
import ThirdLanguageEn1 from "../../Forms/Third Language/ThirdLanguage_En1.png";
import ThirdLanguageEn1Labels from "../../Labels/Third Language/ThirdLanguage_En1.json";
import ThirdLanguageFr1 from "../../Forms/Third Language/ThirdLanguage_Fr1.png";
import ThirdLanguageFr1Labels from "../../Labels/Third Language/ThirdLanguage_Fr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY, signatureTab, signatureLabel
} from "../../PDFGenerationUtils";
import moment from "moment/moment";
import EnrolmentFormsFr3Labels from "../../Labels/Enrolment Forms/EnrolmentForms_Fr3.json";
import EnrolmentFormsEn3Labels from "../../Labels/Enrolment Forms/EnrolmentForms_En3.json";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ThirdLanguageFr1Labels : ThirdLanguageEn1Labels;
    const formImage = isFrench ? ThirdLanguageFr1 : ThirdLanguageEn1;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    const common = data.common;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;

    let subNames = "";

    if (subscriber.firstName && subscriber.lastName) {
        subNames += subscriber.firstName + " " + subscriber.lastName;
    }

    if (common.subscriber2Include && jointSubscriber.firstName && jointSubscriber.lastName) {
        subNames += ", " + jointSubscriber.firstName + " " + jointSubscriber.lastName;
    }

    const drSignDate = moment(new Date()).format("YYYY-MM-DD");

    drawText(common.agentName, "drName");
    drawText(drSignDate, "drSignDate");
    drawText(subNames, "subNames");
    drawText(common.representativeDetailsLanguage ?? "", "thirdLanguage");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ThirdLanguageFr1Labels : ThirdLanguageEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('drSignatureView', labels))],
    });

    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    